import { useEffect } from "react";

export const usePageMeta = (title, description, path) => {
  useEffect(() => {
    document.title = title;
    const setMeta = (selector, attrs) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement(attrs.tag || "meta");
        Object.entries(attrs.create || {}).forEach(([k, v]) => el.setAttribute(k, v));
        document.head.appendChild(el);
      }
      el.setAttribute(attrs.attr, attrs.value);
      return el;
    };
    if (description) {
      setMeta('meta[name="description"]', { attr: "content", value: description, create: { name: "description" } });
      setMeta('meta[property="og:description"]', { attr: "content", value: description, create: { property: "og:description" } });
    }
    setMeta('meta[property="og:title"]', { attr: "content", value: title, create: { property: "og:title" } });
    const canonicalHref = `${window.location.origin}${path || window.location.pathname}`;
    setMeta('link[rel="canonical"]', { tag: "link", attr: "href", value: canonicalHref, create: { rel: "canonical" } });
    setMeta('meta[property="og:url"]', { attr: "content", value: canonicalHref, create: { property: "og:url" } });
  }, [title, description, path]);
};

export const useNoIndex = () => {
  useEffect(() => {
    const m = document.createElement("meta");
    m.name = "robots";
    m.content = "noindex, nofollow";
    document.head.appendChild(m);
    return () => { document.head.removeChild(m); };
  }, []);
};
